
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 14A6 6 0 108 2a6 6 0 000 12z","stroke":"#4A4A4A","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M5.75 7.5a.75.75 0 100-1.5.75.75 0 000 1.5zM10.25 7.5a.75.75 0 100-1.5.75.75 0 000 1.5z","fill":"#4A4A4A"}}),_c('path',{attrs:{"d":"M10.5 9.5C9.981 10.397 9.11 11 8 11s-1.981-.603-2.5-1.5","stroke":"#4A4A4A","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    